import { Component, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Zone } from '@aptsi-types';
import { ZoneMappingRequest, ZoneService } from '../zone.service';
import { MatDialog } from '@angular/material/dialog';
import { EnvironmentService as CoreEnvironmentService } from 'src/app/core/service/environment.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { SuccessDialogComponent } from 'src/app/shared/dialogs/success-dialog/success-dialog.component';
import { ErrorDialogComponent } from 'src/app/shared/dialogs/error-dialog/error-dialog.component';
import { ZoneMapperDialogComponent } from '../zone-mapper-dialog/zone-mapper-dialog.component';
import { AssetService } from '../../../shared/asset.service';      // adjust path
import { EnvironmentService } from '../../environment/environment.service'; // adjust path
import { HierarchicalGridComponent } from 'src/app/shared/table/hierarchical-grid/hierarchical-grid.component';
import { AddChildRendererComponent } from 'src/app/shared/table/hierarchical-grid/add-child-renderer/add-child-renderer.component';

interface AssetParameter {
  // id: string;
  // name: string;
  // values?: string[];
  parameterId?: string;
  parameterName?: string;
  parameterValue?: string;
  parameterValueTypes?: string[];
}


@Component({
  selector: 'app-zone-create-or-update',
  templateUrl: './zone-create-or-update.component.html',
  styleUrls: ['./zone-create-or-update.component.scss']
})
export class ZoneCreateOrUpdateComponent implements OnChanges {
  isCreate = false;
  existingZoneId: string = "";
  zone: Zone | null = null;
  isNextZoneMapping: boolean = false;

  selectedTab: 'zoneDetails' | 'zoneMappings' = 'zoneDetails';
  activeMap: 'asset' | 'environment' | 'zone' = 'asset';
  form: FormGroup;

  // Zone ID from creation (create mode) or existing (update mode)
  zoneId: string = '';

  // Mappings storage
  zoneMappings: any[] = [];      // { assetId, assetName, ... }
  environmentMappings: any[] = []; // { environmentId, environmentName, ... }
  assetMappings: any[] = []; // { assetId, assetName, ... }
  zoneAssets: any[] = []; // Store the fetched zone assets

  segmentMappings: any[] = [];
  controlMappings: any[] = [];
  securityZoneTypes: any[] = [];
  platforms: any[] = [];
  isPlatformsLoading = false;

  selectedSecurityZoneId: string = '';
  private zoneMappingsLoaded = false;

  assetParameters: AssetParameter[] = [];

  selectedParameter: AssetParameter | null = null;

  selectedValue = '';

  parameterMappings: {
    parameterId: string;
    parameterName: string;
    parameterValue: string;
  }[] = [];

  async selectTab(tab: 'zoneDetails' | 'zoneMappings'): Promise<void> {
    this.selectedTab = tab;

    // Load only once, only in update mode
    if (!this.isCreate && tab === 'zoneDetails' && !this.zoneMappingsLoaded && !!this.zoneId) {
      await this.fetchZoneMappings();
      this.zoneMappingsLoaded = true;
    }
  }






  assetHeaders = [
    { name: 'Asset ID', property: 'assetId' },
    { name: 'Asset Name', property: 'assetName' },
    { name: 'Asset Description', property: 'assetDescription' },
    { name: 'Asset Status', property: 'assetStatus' },
    { name: 'Business Value', property: 'businessValue' },
    { name: 'Data Classification', property: 'dataClassification' },
    //{ name: 'Platform', property: 'platform' },

  ];
  environmentHeaders = [
    { name: 'Environment ID', property: 'id' },
    { name: 'Environment Name', property: 'environmentName' }
  ];

  zoneHeaders = [
    { name: 'Zone ID', property: 'id' },
    { name: 'Zone Name', property: 'zoneName' },
    { name: 'Description', property: 'description' }
  ];


  buttonConfig = { delete: true }; // show delete button in tables

  readonly riskTypeOptions = ["High", "Medium", "Low", "None"];
  readonly platformOptions = ["AWS", "Azure", "GCP", "On-Premise", "None"];

  readonly assetTypeOptions = ["None", "DATA", "SYSTEM"];


  // Expose the class as a property to use in the template
  readonly addChildRenderer = AddChildRendererComponent;

  // Table headers & button config
  @ViewChild(HierarchicalGridComponent) hierarchicalGrid!: HierarchicalGridComponent;
  // ---------- raw nested data (your business data) ----------
  rawData = [
    {
      id: 1, name: 'Acme Corp', sector: 'Technology',
      children: [
        { employeeId: 101, employeeName: 'Alice', role: 'Developer', salary: 80000 },
        { employeeId: 102, employeeName: 'Bob', role: 'Designer', salary: 75000 }
      ]
    },
    {
      id: 2, name: 'Globex', sector: 'Finance',
      children: [
        { employeeId: 201, employeeName: 'Charlie', role: 'Analyst', salary: 90000 }
      ]
    }
  ];

  // ---------- flatten it for treeData ----------
  flatRowData = this.flattenData(this.rawData);  // as before

  columnDefs: any[] = [
    { field: 'id', headerName: 'ID', width: 100 },
    { field: 'name', headerName: 'Company', flex: 1 },
    { field: 'sector', headerName: 'Sector', flex: 1 },
    { field: 'employeeId', headerName: 'Emp ID', width: 100 },
    { field: 'employeeName', headerName: 'Employee', flex: 1 },
    { field: 'role', headerName: 'Role', flex: 1 },
    { field: 'salary', headerName: 'Salary', width: 100 }
  ];

  // Optional add child handler
  onAddChild(parent: any): void {
    const newId = Math.floor(Math.random() * 1000).toString();
    const newChild = {
      employeeId: newId,
      employeeName: 'New Employee',
      role: 'Intern',
      salary: 40000,
      orgHierarchy: [parent.id.toString(), newId]
    };

    this.flatRowData.push(newChild);
    this.hierarchicalGrid.refreshGrid();
  }

  // ---------- flatten helper ----------
  private flattenData(parents: any[]): any[] {
    const result: any[] = [];
    parents.forEach(parent => {
      const { children, ...parentRest } = parent;
      result.push({ ...parentRest, orgHierarchy: [parent.id.toString()], children });
      if (children) {
        children.forEach((child: any) => {
          result.push({
            ...child,
            orgHierarchy: [parent.id.toString(), child.employeeId.toString()],
            // no children property on child rows – used to hide the button
          });
        });
      }
    });
    return result;
  }


  constructor(
    private route: ActivatedRoute,
    private zoneService: ZoneService,
    private assetService: AssetService,
    private environmentService: EnvironmentService,
    private dialog: MatDialog,
    private router: Router,
    public coreEnvironmentService: CoreEnvironmentService
  ) { }

  async ngOnInit(): Promise<void> {
    this.isCreate = Boolean(this.route.snapshot.data.create);
    this.existingZoneId = this.route.snapshot.params.zoneId;

    this.initForm();

    this.loadSecurityZoneTypes();

      // Security Zone Type -> Platform dependency
  this.form
  .get('securityZoneTypeId')!
  .valueChanges
  .subscribe((securityZoneTypeId: string) => {

    if (!securityZoneTypeId) {
      this.onSecurityZoneTypeChanged('');
      return;
    }

    const selectedSecurityZoneType = this.securityZoneTypes.find(
      zone => zone.id === securityZoneTypeId
    );

    const securityZoneTypeName =
      selectedSecurityZoneType?.name ?? '';

    this.onSecurityZoneTypeChanged(securityZoneTypeName);
  });

    if (!this.isCreate) {
      await this.fetchZone();

      this.zoneId = this.existingZoneId;

      this.isNextZoneMapping = true; // enable mappings tab
      await this.fetchZoneMappings();
      this.zoneMappingsLoaded = true;
    }





    if (this.isCreate) {
      this.form.get('assetType')!
        .valueChanges
        .subscribe(type => {

          this.onAssetTypeChanged(type);

        });
    }




  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.isCreate && this.selectedTab === 'zoneMappings') {
      //this.fetch
    }
  }


onSecurityZoneTypeChanged(
  securityZoneTypeName: string
): void {

  console.log(
    'Selected Security Zone Type:',
    securityZoneTypeName
  );

  const platformControl = this.form.get('platformName');

  platformControl?.reset('');
  platformControl?.disable();

  this.platforms = [];

  if (!securityZoneTypeName) {
    return;
  }

  this.isPlatformsLoading = true;

  this.zoneService
    .getPlatformsBySecurityZoneType(securityZoneTypeName)
    .subscribe({
      next: (response: any) => {

        this.platforms =
          response?.['Resource retrieved successfully'] ??
          response?.platforms ??
          response ??
          [];

        platformControl?.enable();

        this.isPlatformsLoading = false;
      },

      error: (error) => {
        console.error(
          'Failed to load platforms',
          error
        );

        this.platforms = [];
        platformControl?.disable();

        this.isPlatformsLoading = false;
      }
    });
}

  onAssetTypeChanged(assetType: string): void {

    // Ignore None
    if (assetType === 'None') {

      this.assetParameters = [];
      this.parameterMappings = [];

      this.selectedParameter = null;
      this.selectedValue = '';

      return;
    }

    // Clear old state
    this.assetParameters = [];
    this.parameterMappings = [];

    this.selectedParameter = null;
    this.selectedValue = '';

    this.zoneService
      .getAssetParameters(assetType)
      .subscribe(res => {

        this.assetParameters =
          res;

      });

  }

  async openZoneMapperPopup(type: 'environment' | 'zone') {
    // Pass correct IDs for already selected items
    const alreadySelectedIds = type === 'environment'
      ? this.environmentMappings.map(a => a.assetId)
      : this.zoneMappings.map(e => e.id); // now environmentMappings has 'id'

    const dialogRef = this.dialog.open(ZoneMapperDialogComponent, {
      width: '900px',
      height: '700px',
      data: {
        type: type,
        alreadySelectedIds: alreadySelectedIds
      }
    });

    dialogRef.afterClosed().subscribe(selectedItems => {
      if (selectedItems && selectedItems.length) {
        if (type === 'environment') {
          const newEnvs = selectedItems.filter(
            (item: any) => !this.environmentMappings.some(e => e.id === item.id)
          );
          this.environmentMappings = [
            ...this.environmentMappings,
            ...newEnvs.map(item => ({
              id: item.id,                     // matches table header property 'id'
              environmentName: item.environmentName
            }))
          ];
        } else {
          //For Zone Mapping, we can handle similarly if needed
        }
      }
    });
  }

  get isDropdownValue(): boolean {

    return !!this.selectedParameter &&
      !!this.selectedParameter.parameterValueTypes &&
      this.selectedParameter.parameterValueTypes.length > 0;

  }

  onParameterChange(): void {
    this.selectedValue = '';
  }

  addParameterMapping(): void {

    if (!this.selectedParameter || !this.selectedValue.trim()) {
      return;
    }

    const alreadyExists = this.parameterMappings.find(
      x => x.parameterId === this.selectedParameter?.parameterId
    );

    if (alreadyExists) {

      alreadyExists.parameterValue = this.selectedValue;

    } else {

      this.parameterMappings.push({

        parameterId: this.selectedParameter.parameterId,
        parameterName: this.selectedParameter.parameterName,
        parameterValue: this.selectedValue

      });

    }

    this.selectedParameter = null;
    this.selectedValue = '';

  }

  removeParameterMapping(parameterId: string): void {

    this.parameterMappings =
      this.parameterMappings.filter(
        x => x.parameterId !== parameterId
      );

  }


  //   async fetchZoneMappings(): Promise<void> {
  //   if (!this.zoneId) return;

  //   try {
  //     const response: any = await this.zoneService.fetchZoneMappings(this.zoneId).toPromise();

  //     const raw =
  //       response?.['Resource retrieved successfully']?.[0] ??
  //       response?.['Resource retrieved successfully'] ??
  //       response;

  //     const assetRows = raw?.assetIds ?? raw?.assets ?? raw?.assetMappings ?? [];
  //     const envRows = raw?.environmentIds ?? raw?.environments ?? raw?.environmentMappings ?? [];

  //     this.assetMappings = assetRows.map((item: any) => {
  //       if (typeof item === 'string') {
  //         return { assetId: item, name: '' };
  //       }

  //       return {
  //         assetId: item.assetId ?? item.id ?? item.asset_id ?? '',
  //         name: item.name ?? item.assetName ?? item.asset_name ?? ''
  //       };
  //     });

  //     this.environmentMappings = envRows.map((item: any) => {
  //       if (typeof item === 'string') {
  //         return { id: item, environmentName: '' };
  //       }

  //       return {
  //         id: item.id ?? item.environmentId ?? item.environment_id ?? '',
  //         environmentName: item.environmentName ?? item.name ?? item.environment_name ?? ''
  //       };
  //     });
  //   } catch (error: any) {
  //     console.error('Failed to fetch zone mappings', error);
  //     this.openErrorDialog(error?.message || 'Failed to load zone mappings');
  //   }
  // }

  async fetchZoneMappings(): Promise<void> {
    if (!this.zoneId) return;

    try {
      const response = await this.zoneService
        .fetchZoneMappings(this.zoneId)
        .toPromise();

      // this.zoneMappings = response.assets.map(zone => ({
      //   zoneId: zone.id,
      //   name: zone.name
      // }));

      this.environmentMappings = response.environments.map(environment => ({
        id: environment.id,
        environmentName: environment.name
      }));

      this.assetMappings = response.assets.map(asset => ({
        assetId: asset.assetId,
        assetName: asset.assetName,
        assetDescription: asset.description,
        assetStatus: asset.assetStatus,
        businessValue: asset.businessValue,
        dataClassification: asset.dataClassification,
        platform: asset.platform
      }));

      this.zoneMappings = response.securityZones.map(asset => ({
        id: asset.id,
        zoneName: asset.zoneName,
        description: asset.description,
      }));



      //  { name: 'Asset ID', property: 'assetId' },
      // { name: 'Asset Name', property: 'assetName' },
      // { name: 'Asset Description', property: 'assetDescription' },
      // { name: 'Asset Status', property: 'assetStatus' },
      // { name: 'Business Value', property: 'businessValue' },
      // { name: 'Data Classification', property: 'dataClassification' },
      // { name: 'Platform', property: 'platform' },

    } catch (error: any) {
      console.error('Failed to fetch zone mappings', error);
      this.openErrorDialog(
        error?.message || 'Failed to load zone mappings'
      );
    }
  }

  loadSecurityZoneTypes(): void {
    this.zoneService.getSecurityZoneTypes().subscribe({
      next: (response: any) => {
        this.securityZoneTypes =
          response['Resource retrieved successfully'] || [];
      },
      error: (error) => {
        console.error('Failed to load Security Zone Types', error);
      }
    });

    console.log("Security zone types are: ", this.securityZoneTypes)
  }

private initForm(): void {
  if (this.isCreate) {
    this.form = new FormGroup({
      zoneName: new FormControl(null, Validators.required),
      securityZoneTypeId: new FormControl('', Validators.required),
      platformName: new FormControl(
        { value: '', disabled: true },
        Validators.required
      ),
      description: new FormControl(null, Validators.required),
      assetType: new FormControl('None', [
        Validators.required,
        this.typeValidator
      ]),
    });
  } else {
    this.form = new FormGroup({
      zoneId: new FormControl(this.existingZoneId, Validators.required),
      zoneName: new FormControl(this.zone?.zoneName || null, Validators.required),

      // Disabled on update screen
      securityZoneTypeId: new FormControl(
        { value: this.zone?.securityZoneTypeId || null, disabled: true },
        Validators.required
      ),

      platformName: new FormControl(
        { value: this.zone?.platformName || null, disabled: true },
        Validators.required
      ),

      description: new FormControl(this.zone?.description || null, Validators.required),

      // Disabled on update screen
      assetType: new FormControl(
        { value: this.zone?.assetType || 'None', disabled: true },
        [Validators.required, this.typeValidator]
      ),
    });
  }
}

  async fetchZone() {
    try {
      const response = await this.zoneService.getZone(this.existingZoneId).toPromise();

      this.zone = response.securityZone;

      if (this.zone) {
        this.form.patchValue({
          zoneName: this.zone.zoneName,
          description: this.zone.description,
          securityZoneTypeId: this.zone.securityZoneTypeId,
          risk: this.zone.risk,
          assetType: this.zone.assetType,
          platformName:this.zone.platformName
        });
      }

      // Existing mappings
      this.parameterMappings = response.parameters ?? [];

      // Load dropdown parameters
      await this.loadAssetParameters(response.securityZone.assetType);

    } catch (error) {
      console.error(error);
    }
  }

  private async loadAssetParameters(assetType: string): Promise<void> {

    this.assetParameters = [];
    this.selectedParameter = null;
    this.selectedValue = '';

    if (!assetType || assetType === 'None') {
      return;
    }

    this.assetParameters = await this.zoneService
      .getAssetParameters(assetType)
      .toPromise();
  }

  typeValidator(control: AbstractControl): { [key: string]: any } | null {
    return control.value === "None" ? { noneSelected: true } : null;
  }

  // Called when clicking Next in Zone Details (create mode) or Save in update mode
  async submit() {
    try {
      if (this.isCreate) {
        // Create zone first
        const res = await this.zoneService.createZone(
          this.form.value.zoneName,
          this.form.value.description,
          this.form.value.securityZoneTypeId,
          this.form.value.platformName,
          this.form.value.assetType,
          this.parameterMappings
        ).toPromise();
        console.log("Zone response for create is: ", res)
        // Extract zoneId from response – adjust according to your API response
        this.zoneId = res?.securityZoneId;

        if (!this.zoneId) {
          throw new Error('Zone ID not returned from creation');
        }

        // Move to mappings tab
        this.isNextZoneMapping = true;
        this.selectedTab = 'zoneMappings';
        this.fetchZoneZoneMappingInfo(res); // Fetch assets for the newly created zone


      } else {
        // Update zone
        await this.zoneService.updateZone(
          this.form.value.zoneId,
          this.form.value.zoneName,
          this.form.value.description,
        ).toPromise();

        // For update, after saving details, optionally go to mappings or stay?
        // Requirement not explicit – we'll show success and navigate.
        this.openSuccessDialog(this.isCreate);
      }
    } catch (error) {
      this.openErrorDialog(error.message || "An unexpected error occurred.");
    }
  }


  async fetchZoneZoneMappingInfo(res: Zone): Promise<void> {
    const response = await this.zoneService.fetchZoneAssets(res).toPromise();
    this.zoneAssets = response["assets"] || [];

    this.assetMappings = this.zoneAssets.map(asset => ({
      assetId: asset.assetId,
      assetName: asset.assetName,
      assetDescription: asset.description,
      assetStatus: asset.status,
      businessValue: asset.businessValue,
      dataClassification: asset.dataClassification,
      platform: asset.platform
    }));
    
    this.environmentMappings = response["environements"] || [];
    this.zoneMappings = response["securityZones"] || [];
    console.log("Fetched zone assets are: ", this.zoneAssets)
  }







  // openSegmentControlMapperPopup(type:'segment' | 'control'){

  // }

  private getIdField(type: string): string {
    return type === 'asset' ? 'assetId' : 'environmentId';
  }

  // Handle delete action from tables
  handleAction(event: { action: string, rowIndex: number, rowData: any }) {
    if (event.action === 'delete') {
      if (this.activeMap === 'environment') {
        this.environmentMappings = this.environmentMappings.filter((_, idx) => idx !== event.rowIndex);
      }
    }
  }

  // Check if finish can be enabled
  get canGoTosegmentControlMappings(): boolean {
    return this.assetMappings.length > 0 && this.environmentMappings.length > 0;
  }

  // async submitZoneMapping(){
  //    if (!this.canGoTosegmentControlMappings) return;
  //      const payload: any = {
  //        securityZoneId: this.zoneId,
  //        environmentIds: this.environmentMappings.map(e => e.id),
  //        assetIds: this.assetMappings.map(a => a.assetId),
  //        zoneIds:this.zoneAssets.map(z=>z.id)
  //     };
  //       try {
  //   // Step 1: Create mappings

  //   if(this.isCreate){
  //       const mappingResponse = await this.zoneService
  //     .createZoneMappings(payload)
  //     .toPromise();


  //   // Step 3: Show success
  //   this.openSuccessDialog(this.isCreate);
  //   }
  //   else{
  //     await this.zoneService.updateZoneMappings(payload).toPromise();
  //     this.openSuccessDialog(this.isCreate);
  //   }

  // } catch (error: any) {
  //   this.openErrorDialog(
  //     error?.message || 'Failed to save mappings'
  //   );
  // }
  // }

  //Finish: send mappings to backend
  async finish() {
    // if (!this.canGoTosegmentControlMappings) return;

    console.log("zoneAssets", this.zoneAssets);
    console.log("assetMappings", this.assetMappings);
    const payload: ZoneMappingRequest = {
      securityZoneId: this.zoneId,
      environmentIds: this.environmentMappings.map(e => e.id),
      assetIds: this.assetMappings.map(a => a.assetId),
      securityZoneIds: this.zoneMappings.map(z => z.id)
    };

    try {
      // Step 1: Create mappings

      if (this.isCreate) {
        const mappingResponse = await this.zoneService
          .createZoneMappings(payload)
          .toPromise();

        // Step 2: Only after successful response, finish mappings
        await this.zoneService
          .finishZoneMappings(this.zoneId)
          .toPromise();

        // Step 3: Show success
        this.openSuccessDialog(this.isCreate);
      }
      else {
        await this.zoneService.updateZoneMappings(payload).toPromise();
        this.openSuccessDialog(this.isCreate);
      }


    } catch (error: any) {
      this.openErrorDialog(
        error?.message || 'Failed to save mappings'
      );
    }
  }


  cancel() {
    this.router.navigate(["secure-zone/zone/search"]);
  }

  openSuccessDialog(isCreate: boolean): void {
    this.dialog.open(SuccessDialogComponent, {
      width: "250px",
      data: { isCreate: isCreate, isCreateUpdate: true, title: "Zone" }
    }).afterClosed().subscribe(() => {
      this.router.navigate(["secure-zone/zone/search"]);
    });
  }

  openErrorDialog(errorMessage: string): void {
    this.dialog.open(ErrorDialogComponent, {
      width: "250px",
      data: { errorMessage }
    });
  }

  // For tables: expose final entries (derived from arrays)
  get finalAssetEntries() {
    return this.assetMappings;
  }

  get finalSecurityZoneEntries() {
    return this.zoneMappings;
  }

  get finalEnvironmentEntries() {
    return this.environmentMappings;
  }
}
